import { createApp } from 'vue'
import App from './App.vue'
import { key, store } from './store'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { setupIcons } from '@/FontAwesomeIcons'
import VueTippy from 'vue-tippy'

setupIcons()

createApp(App)
    .component('font-awesome-icon', FontAwesomeIcon)
    .component('font-awesome-layers', FontAwesomeLayers)
    .component('font-awesome-layers-text', FontAwesomeLayersText)
    .use(VueTippy, {
        defaultProps: {
            animation: 'fade',
            arrow: false,
            theme: 'custom'
        }
    })
    .use(store, key)
    .mount('#app')
